import _ from 'lodash'

const isJSON = data => {
  if (data === 'true' || data === 'false') return false
  try {
    const parsed = JSON.parse(data)
    if (_.isNumber(parsed)) return false
    return true
  } catch (e) {
    return false
  }
}

const parseJSONData = payloadString => {
  let obj
  try {
    obj = JSON.parse(payloadString)
  } catch (e) {
    // eat it...
  }
  return obj
}

export { isJSON, parseJSONData }
